export const base = {
  background: "#000",
  accentForeground: "#9ff8a0",
} as const;

export const focus = {
  accentForegroundFocus: "#c19ff8",
} as const;
